import { marked } from 'marked';

/**
 * Render a markdown string to HTML. Bot/agent replies arrive with markdown
 * (**bold**, ### headings, - lists, 1. steps); without this the literal
 * `###`/`**` show as an unreadable wall. The output MUST still be passed
 * through sanitizeHtml before insertion into the DOM.
 *
 * breaks:true turns single newlines into <br> so plain-text line breaks the
 * bot emits survive without needing white-space: pre-wrap on the bubble.
 */
export function renderMarkdown(md: string): string {
  return marked.parse(md ?? '', { gfm: true, breaks: true, async: false }) as string;
}
